import React from 'react'

import Layout from '../components/layout'
import HomeTwo from '../components/home/HomeTwo'
import ServiceCapabilities from '../components/services/ServiceCapabilities'
import ServiceOneTeam from '../components/services/ServiceOneTeam'
import ServiceOtherSolutions from '../components/services/ServiceOtherSolutions'
import ServicePageHero from '../components/services/ServicePageHero'
import { CLOUD_INFRASTRUCTURE_CAPABILITIES_PT } from '../constants/serviceCapabilitiesCloudInfrastructure'
import { SERVICE_ONE_TEAM_APPLICATION_PT } from '../constants/serviceOneTeamContent'
import { createServiceOtherSolutionsPt } from '../constants/serviceOtherSolutionsContent'
import { SERVICE_HERO_ASSETS, SERVICE_PAGE_PILLAR_ICONS } from '../constants/serviceHeroAssets'

const CloudInfraestruturaPagePt = () => (
  <Layout lang="pt" title="Cloud & Infraestrutura" meta={{ description: '' }} rootProps={{ className: 'page services service-application-modernization' }}>
    <div className="service-detail-page">
      <ServicePageHero
        sectionId="service-hero"
        label="Serviços"
        title={'Cloud & Infraestrutura.'}
        description={
          'Da arquitetura cloud ao DevOps e otimização, construímos infraestruturas fiáveis que suportam produtos digitais modernos.'
        }
        heroImage={SERVICE_HERO_ASSETS.cloud.src}
        imageAlt="Ilustração de cloud e infraestrutura"
        imageWidth={SERVICE_HERO_ASSETS.cloud.width}
        imageHeight={SERVICE_HERO_ASSETS.cloud.height}
        pillarIcon={SERVICE_PAGE_PILLAR_ICONS.cloud.src}
        pillarIconWidth={SERVICE_PAGE_PILLAR_ICONS.cloud.width}
      />
      <ServiceCapabilities
        idBase="service-capabilities-cloud-infrastructure"
        sectionTitle="Capacidades criadas para Escala & Performance."
        tabs={CLOUD_INFRASTRUCTURE_CAPABILITIES_PT}
        contactCtaIsEn={false}
      />
      <HomeTwo lang="pt" />
      <ServiceOneTeam
        idBase="service-one-team-cloud-infrastructure"
        {...SERVICE_ONE_TEAM_APPLICATION_PT}
      />
      <ServiceOtherSolutions
        idBase="service-other-solutions-cloud-infrastructure"
        {...createServiceOtherSolutionsPt('cloud')}
      />
    </div>
  </Layout>
)

export default CloudInfraestruturaPagePt
